import React, { useEffect, useState } from "react";
import "./styles.css";
import { Container, Table } from "react-bootstrap";
import LoadingPage from "../../Components/LoadingPage/LoadingPage";
import { BLANK_STRING } from "../../constants/appConstants";
import { useNavigate, useParams } from "react-router-dom";
import { getManagementReviewsDataAPI } from "../../apiRequests/management-reviews/getManagementReviewsDataAPI";

interface ManagementReviewsProps {
    isDashboard?: boolean;
    dataMRs?: any;
}

const ManagementReviews = (props: ManagementReviewsProps) => {
    const navigate = useNavigate();
    const { year } = useParams();
    const [dataMRs, setDataMRs] = useState<any>([]);

    const [selectedYear, setSelectedYear] = useState<string>(BLANK_STRING);

    useEffect(() => {
        !props.isDashboard && getMRDataAndSetToState();
    }, []);

    useEffect(() => {
        if (selectedYear) {
            !props.isDashboard && navigate(`/management-reviews/${exportYear(selectedYear)}`, { replace: true });
        }
    }, [selectedYear]);

    useEffect(() => {
        if (dataMRs.length) {
            setCurrentYearAndQuarter();
        }
    }, [year, dataMRs]);

    useEffect(() => {
        if (props.isDashboard) {
            setDataMRs(props.dataMRs);
        }
    }, [props.dataMRs, props.isDashboard]);

    const exportYear = (yearString: string) => {
        const match = yearString.match(/\d{4}/);
        const year = match ? match[0] : null;
        return year;
    };

    const setCurrentYearAndQuarter = () => {
        if (year) {
            const currentMR = dataMRs.find((data: any) => {
                return exportYear(data.title) === year.toString();
            });
            setSelectedYear(currentMR?.title || BLANK_STRING);
        } else {
            const currentYear = new Date().getFullYear();
            const currentMR = dataMRs.find((data: any) => {
                return exportYear(data.title) === currentYear.toString();
            });
            setSelectedYear(currentMR?.title || BLANK_STRING);
            !props.isDashboard && navigate(`/management-reviews/${currentYear}`, { replace: true });
        }
    };

    const getMRDataAndSetToState = async () => {
        const dataMRs: any = await getManagementReviewsDataAPI();
        setDataMRs(dataMRs);
    };

    const renderSelectMRsYear = () => {
        return (
            <div className="selector-container">
                <label className="label" htmlFor="year">
                    Select Year:
                </label>
                <select
                    className="select"
                    id="year"
                    value={selectedYear}
                    onChange={(event) => {
                        setSelectedYear(event.target.value);
                    }}
                >
                    <option disabled value="">
                        Select Year
                    </option>
                    {dataMRs.map((data: any) => {
                        return (
                            <option key={data.title} value={data.title}>
                                {data.title}
                            </option>
                        );
                    })}
                </select>
            </div>
        );
    };

    const renderMRsDataTable = () => {
        const dataMRsInSelectedYear = dataMRs.find((data: any) => {
            return data.title === selectedYear;
        });

        return (
            <>
                <p>Number of Management Reviews: {dataMRsInSelectedYear.data.length}</p>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>ID</th>
                            <th>TITLE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataMRsInSelectedYear.data.map((data: any, index: number) => {
                            return (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{data.id}</td>
                                    <td>
                                        <a href={data.link} target="_blank">
                                            {data.title}
                                        </a>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </>
        );
    };

    const renderLoading = () => {
        return <LoadingPage></LoadingPage>;
    };

    const renderMainContentOfManagementReviews = () => {
        return (
            <>
                {renderSelectMRsYear()}
                {selectedYear && renderMRsDataTable()}
            </>
        );
    };
    return <Container>{dataMRs.length ? renderMainContentOfManagementReviews() : renderLoading()}</Container>;
};

export default ManagementReviews;
